import * as constants from './constants'

export const getReservations = () => ({
    type: constants.GET_RESERVATIONS,
})

export const setReservations = reservations => ({
    type: constants.SET_RESERVATIONS,
    reservations,
})

export const getRecentNews = () => ({
    type: constants.GET_RECENT_NEWS,
})

export const setRecentNews = news => ({
    type: constants.SET_RECENT_NEWS,
    news,
})
